export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.call-history-list', {
      url: 'call-history',
      template: '<nets-call-history-list></nets-call-history-list>',
    });
};
